<template>
  <div id="searchKeyMgmt" class="search-key-mgmt">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>销售分析</el-breadcrumb-item>
        <el-breadcrumb-item>爬取搜索词</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="section-card">
      <div class="section-title">Excel 导入</div>
      <div class="upload-row">
        <span class="hint">列名：shop、key、排名、点击率No1、点击率No2、点击率No3</span>
        <el-upload
          ref="uploader"
          class="upload-inline"
          action=""
          accept=".xls,.xlsx"
          :auto-upload="false"
          :limit="1"
          :on-change="onFileChange"
          :on-remove="onFileRemove"
          :file-list="uploadFileList"
        >
          <el-button size="small">选取 Excel</el-button>
        </el-upload>
        <el-button type="primary" size="small" :loading="uploading" @click="onUploadSubmit(false)">导入</el-button>
        <el-button type="warning" size="small" :loading="overwriteUploading" @click="openOverwriteDialog">覆盖导入</el-button>
      </div>
    </div>

    <div class="section-card">
      <div class="section-title">查询条件</div>
      <div class="header-line">
        <span class="header-label">店铺</span>
        <el-select v-model="query.shopId" size="small" clearable placeholder="全部" style="width: 140px">
          <el-option v-for="item in shopOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
        <span class="header-label">类型</span>
        <el-select v-model="query.type" size="small" clearable placeholder="全部" style="width: 120px">
          <el-option label="搜索词" :value="1" />
          <el-option label="店铺链接" :value="2" />
        </el-select>
        <span class="header-label">状态</span>
        <el-select v-model="query.status" size="small" clearable placeholder="全部" style="width: 100px">
          <el-option label="启用" :value="1" />
          <el-option label="禁用" :value="0" />
        </el-select>
        <span class="header-label">搜索词</span>
        <el-input v-model="query.key" size="small" clearable placeholder="模糊匹配" style="width: 180px" />
        <el-button type="primary" size="small" @click="onQuery">查询</el-button>
        <el-button type="success" size="small" @click="openDialog()">新增</el-button>
      </div>
    </div>

    <div class="main-box">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        border
        stripe
        size="small"
        :height="screenHeight"
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="72" align="center" />
        <el-table-column prop="shopName" label="店铺" width="100" show-overflow-tooltip />
        <el-table-column prop="typeDesc" label="类型" width="90" align="center" />
        <el-table-column prop="key" label="搜索词" min-width="160" show-overflow-tooltip />
        <el-table-column prop="keyRank" label="排名" width="70" align="center">
          <template slot-scope="scope">{{ scope.row.keyRank != null ? scope.row.keyRank : "—" }}</template>
        </el-table-column>
        <el-table-column prop="clickRateNo1" label="点击率No1" width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.clickRateNo1 || "—" }}</template>
        </el-table-column>
        <el-table-column prop="clickRateNo2" label="点击率No2" width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.clickRateNo2 || "—" }}</template>
        </el-table-column>
        <el-table-column prop="clickRateNo3" label="点击率No3" width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.clickRateNo3 || "—" }}</template>
        </el-table-column>
        <el-table-column label="来源" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.sourceType === 2 ? 'warning' : 'primary'" size="mini">
              {{ scope.row.sourceTypeDesc || (scope.row.sourceType === 2 ? "导入" : "手动新增") }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pageCount" label="爬取页数" width="90" align="center" />
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
              {{ scope.row.statusDesc }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="170">
          <template slot-scope="scope">{{ formatTime(scope.row.updateTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDialog(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="onSwitchSourceType(scope.row)">
              {{ scope.row.sourceType === 2 ? "转为手动" : "转为导入" }}
            </el-button>
            <el-button type="text" size="small" style="color: #f56c6c" @click="onDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager-wrap">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          :total="totalRecords"
          @size-change="onPageSizeChange"
          @current-change="loadList"
        />
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" @close="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="100px" size="small">
        <el-form-item label="店铺" prop="shopId">
          <el-select v-model="form.shopId" placeholder="请选择店铺" style="width: 100%">
            <el-option v-for="item in shopOptions" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型" style="width: 100%">
            <el-option label="搜索词" :value="1" />
            <el-option label="店铺链接" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="搜索词" prop="key">
          <el-input v-model="form.key" clearable placeholder="搜索词或店铺链接" />
        </el-form-item>
        <el-form-item label="排名" prop="keyRank">
          <el-input-number v-model="form.keyRank" :min="0" :controls="true" style="width: 100%" />
        </el-form-item>
        <el-form-item label="点击率No1" prop="clickRateNo1">
          <el-input v-model="form.clickRateNo1" clearable placeholder="可选" />
        </el-form-item>
        <el-form-item label="点击率No2" prop="clickRateNo2">
          <el-input v-model="form.clickRateNo2" clearable placeholder="可选" />
        </el-form-item>
        <el-form-item label="点击率No3" prop="clickRateNo3">
          <el-input v-model="form.clickRateNo3" clearable placeholder="可选" />
        </el-form-item>
        <el-form-item label="爬取页数" prop="pageCount">
          <el-input-number v-model="form.pageCount" :min="1" :max="20" style="width: 100%" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="onSave">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="覆盖导入" :visible.sync="overwriteDialogVisible" width="480px">
      <div class="overwrite-tip">
        将先物理删除已有搜索词再导入 Excel 新数据。未勾选「覆盖手动新增」时仅删除来源为导入的记录；勾选后删除全部记录。
      </div>
      <div class="overwrite-field">
        <span class="overwrite-label">覆盖店铺</span>
        <el-select v-model="overwriteShopId" size="small" placeholder="全部店铺" style="width: 100%">
          <el-option label="全部" value="" />
          <el-option v-for="item in shopOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </div>
      <div class="overwrite-field-hint">选择「全部」覆盖所有店铺；选择具体店铺时仅覆盖该店铺下的数据。</div>
      <el-checkbox v-model="overwriteManual">覆盖手动新增的记录</el-checkbox>
      <span slot="footer">
        <el-button size="small" @click="overwriteDialogVisible = false">取消</el-button>
        <el-button type="warning" size="small" :loading="overwriteUploading" @click="onUploadSubmit(true)">确认覆盖导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { searchKeyModules } from "@r";

const SOURCE_MANUAL = 1;
const SOURCE_IMPORT = 2;

export default {
  name: "SearchKeyMgmt",
  data() {
    return {
      shopOptions: [],
      query: {
        shopId: null,
        type: null,
        status: null,
        key: ""
      },
      tableData: [],
      listLoading: false,
      currentPage: 1,
      pageSize: 20,
      totalRecords: 0,
      shopLoaded: false,
      screenHeight: document.body.clientHeight - 64 - 280,
      uploadFileList: [],
      currentFile: null,
      uploading: false,
      overwriteUploading: false,
      overwriteDialogVisible: false,
      overwriteManual: false,
      overwriteShopId: "",
      dialogVisible: false,
      saving: false,
      form: {
        id: null,
        shopId: null,
        type: 1,
        key: "",
        keyRank: null,
        clickRateNo1: "",
        clickRateNo2: "",
        clickRateNo3: "",
        pageCount: 1,
        status: 1
      },
      formRules: {
        shopId: [{ required: true, message: "请选择店铺", trigger: "change" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        key: [{ required: true, message: "请输入搜索词", trigger: "blur" }]
      }
    };
  },
  computed: {
    dialogTitle() {
      return this.form.id ? "编辑搜索词" : "新增搜索词";
    }
  },
  activated() {
    if (!this.shopLoaded) {
      this.loadShops();
    }
    this.loadList();
  },
  mounted() {
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 280;
    },
    formatTime(ts) {
      if (ts == null || ts === "") return "—";
      const d = new Date(Number(ts));
      if (isNaN(d.getTime())) return "—";
      const pad = n => (n < 10 ? "0" + n : "" + n);
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    loadShops() {
      searchKeyModules
        .shopList()
        .then(res => {
          if (res.code === "00000") {
            this.shopOptions = res.data || [];
            this.shopLoaded = true;
          }
        })
        .catch(() => {});
    },
    onQuery() {
      this.currentPage = 1;
      this.loadList();
    },
    onPageSizeChange() {
      this.currentPage = 1;
      this.loadList();
    },
    loadList() {
      const params = {
        currentPage: this.currentPage,
        pageSize: Math.min(this.pageSize, 100)
      };
      if (this.query.shopId != null && this.query.shopId !== "") {
        params.shopId = this.query.shopId;
      }
      if (this.query.type != null && this.query.type !== "") {
        params.type = this.query.type;
      }
      if (this.query.status != null && this.query.status !== "") {
        params.status = this.query.status;
      }
      const kw = (this.query.key || "").trim();
      if (kw) {
        params.key = kw;
      }
      this.listLoading = true;
      searchKeyModules
        .page(params)
        .then(res => {
          this.listLoading = false;
          if (res.code !== "00000") {
            this.tableData = [];
            this.totalRecords = 0;
            this.$message.error(res.msg || "查询失败");
            return;
          }
          const page = res.data || {};
          this.tableData = page.records || [];
          this.totalRecords = page.total != null ? Number(page.total) : 0;
          if (page.current != null) {
            this.currentPage = Number(page.current);
          }
          if (page.size != null) {
            this.pageSize = Number(page.size);
          }
        })
        .catch(err => {
          this.listLoading = false;
          this.tableData = [];
          this.totalRecords = 0;
          this.$message.error((err && err.msg) || "查询失败");
        });
    },
    onFileChange(file, fileList) {
      this.currentFile = file.raw;
      this.uploadFileList = fileList.slice(-1);
    },
    onFileRemove() {
      this.currentFile = null;
      this.uploadFileList = [];
    },
    openOverwriteDialog() {
      if (!this.currentFile) {
        this.$message.warning("请先选择 Excel 文件");
        return;
      }
      if (!this.shopLoaded) {
        this.loadShops();
      }
      this.overwriteManual = false;
      this.overwriteShopId = "";
      this.overwriteDialogVisible = true;
    },
    onUploadSubmit(overwriteImport) {
      if (!this.currentFile) {
        this.$message.warning("请先选择 Excel 文件");
        return;
      }
      const fd = new FormData();
      fd.append("file", this.currentFile);
      fd.append("overwriteImport", overwriteImport ? "true" : "false");
      fd.append("overwriteManual", overwriteImport && this.overwriteManual ? "true" : "false");
      if (overwriteImport && this.overwriteShopId !== "" && this.overwriteShopId != null) {
        fd.append("overwriteShopId", this.overwriteShopId);
      }

      const loadingKey = overwriteImport ? "overwriteUploading" : "uploading";
      this[loadingKey] = true;
      searchKeyModules
        .upload(fd)
        .then(res => {
          this[loadingKey] = false;
          if (res.code !== "00000") {
            this.$message.error(res.msg || "导入失败");
            return;
          }
          this.$message.success(overwriteImport ? "覆盖导入成功" : "导入成功");
          this.overwriteDialogVisible = false;
          this.uploadFileList = [];
          this.currentFile = null;
          if (this.$refs.uploader) {
            this.$refs.uploader.clearFiles();
          }
          this.currentPage = 1;
          this.loadList();
        })
        .catch(err => {
          this[loadingKey] = false;
          this.$message.error((err && err.msg) || "导入失败");
        });
    },
    openDialog(row) {
      if (row) {
        this.form = {
          id: row.id,
          shopId: row.shopId,
          type: row.type,
          key: row.key,
          keyRank: row.keyRank != null ? row.keyRank : null,
          clickRateNo1: row.clickRateNo1 || "",
          clickRateNo2: row.clickRateNo2 || "",
          clickRateNo3: row.clickRateNo3 || "",
          pageCount: row.pageCount != null ? row.pageCount : 1,
          status: row.status != null ? row.status : 1
        };
      } else {
        this.resetForm();
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    resetForm() {
      this.form = {
        id: null,
        shopId: null,
        type: 1,
        key: "",
        keyRank: null,
        clickRateNo1: "",
        clickRateNo2: "",
        clickRateNo3: "",
        pageCount: 1,
        status: 1
      };
    },
    onSave() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return;
        this.saving = true;
        const payload = {
          shopId: this.form.shopId,
          type: this.form.type,
          key: this.form.key,
          status: this.form.status,
          pageCount: this.form.pageCount
        };
        if (this.form.keyRank != null && this.form.keyRank !== "") {
          payload.keyRank = this.form.keyRank;
        }
        if ((this.form.clickRateNo1 || "").trim()) {
          payload.clickRateNo1 = this.form.clickRateNo1.trim();
        }
        if ((this.form.clickRateNo2 || "").trim()) {
          payload.clickRateNo2 = this.form.clickRateNo2.trim();
        }
        if ((this.form.clickRateNo3 || "").trim()) {
          payload.clickRateNo3 = this.form.clickRateNo3.trim();
        }
        if (this.form.id != null) {
          payload.id = this.form.id;
        }
        searchKeyModules
          .save(payload)
          .then(res => {
            this.saving = false;
            if (res.code !== "00000") {
              this.$message.error(res.msg || "保存失败");
              return;
            }
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.loadList();
          })
          .catch(err => {
            this.saving = false;
            this.$message.error((err && err.msg) || "保存失败");
          });
      });
    },
    onSwitchSourceType(row) {
      const targetType = row.sourceType === SOURCE_IMPORT ? SOURCE_MANUAL : SOURCE_IMPORT;
      const actionText = targetType === SOURCE_MANUAL ? "转为手动新增" : "转为导入";
      this.$confirm(`确认将该记录${actionText}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => searchKeyModules.switchSourceType(row.id, targetType))
        .then(res => {
          if (res.code !== "00000") {
            this.$message.error(res.msg || "操作失败");
            return;
          }
          this.$message.success("操作成功");
          this.loadList();
        })
        .catch(e => {
          if (e === "cancel") return;
          this.$message.error((e && e.msg) || "操作失败");
        });
    },
    onDelete(row) {
      this.$confirm("确认删除该搜索词？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => searchKeyModules.delete(row.id))
        .then(res => {
          if (res.code !== "00000") {
            this.$message.error(res.msg || "删除失败");
            return;
          }
          this.$message.success("删除成功");
          this.loadList();
        })
        .catch(e => {
          if (e === "cancel") return;
          this.$message.error((e && e.msg) || "删除失败");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-key-mgmt {
  width: 100%;
  margin: 0 auto;
  background: white;
  padding: 12px 16px 16px;
}
.breadcrumb-box {
  margin-bottom: 12px;
}
.section-card {
  margin-bottom: 12px;
  padding: 12px 14px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.section-title {
  font-weight: 600;
  margin-bottom: 10px;
  color: #303133;
}
.header-line,
.upload-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.header-label {
  color: #606266;
  font-size: 13px;
}
.hint {
  color: #909399;
  font-size: 12px;
}
.upload-inline {
  display: inline-block;
}
.main-box {
  margin-top: 4px;
}
.pager-wrap {
  margin-top: 12px;
  text-align: right;
}
.overwrite-tip {
  margin-bottom: 16px;
  color: #606266;
  font-size: 13px;
  line-height: 1.6;
}
.overwrite-field {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.overwrite-label {
  flex-shrink: 0;
  width: 72px;
  color: #606266;
  font-size: 13px;
}
.overwrite-field-hint {
  margin-bottom: 16px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
</style>
